import { useEffect, useRef } from "react";
import { getCalApi } from "@calcom/embed-react";
import { useTheme } from "@/contexts/ThemeContext";
import { CAL_NAMESPACE, CAL_LINK, CAL_CLICK_CONFIG } from "@/config/calEmbed";

interface CalendarDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

/**
 * Triggers Cal.com's native element-click modal (namespace "ifa") so the
 * booking surface matches Cal's stock popup. bookingSuccessfulV2 still
 * fires the Meta Pixel Schedule conversion registered in useCalEmbed.
 */
const CalendarDialog = ({ open, onOpenChange }: CalendarDialogProps) => {
  const { theme } = useTheme();
  const wasOpen = useRef(false);

  useEffect(() => {
    if (!open || wasOpen.current) {
      wasOpen.current = open;
      return;
    }
    wasOpen.current = true;

    (async () => {
      try {
        const cal = await getCalApi({ namespace: CAL_NAMESPACE });
        cal("ui", {
          hideEventTypeDetails: false,
          layout: "month_view",
          theme: theme === "dark" ? "dark" : "light",
        });
        cal("modal", {
          calLink: CAL_LINK,
          config: { ...CAL_CLICK_CONFIG, theme: theme === "dark" ? "dark" : "light" },
        });
        cal("on", {
          action: "__closeIframe",
          callback: () => onOpenChange(false),
        });
      } catch (e) {
        console.warn("Cal modal open failed", e);
      }
    })();
  }, [open, theme, onOpenChange]);

  return null;
};

export default CalendarDialog;
